import React, { Component } from "react"
import { Button } from "reactstrap"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
  Container,
  Row,
  Col,
  Modal,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import WebsiteList from "./WebsiteList";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

// Utilities
import {
  createNotificationHelpers,
  loadScannerWebsitesData,
  createScannerWebsite,
  updateScannerWebsite,
  transformScannerWebsitesToTableData,
  SCANNER_WEBSITE_TABLE_COLUMNS,
  MESSAGES
} from "../utils";

class ScannerWebsite extends Component {
  constructor(props) {
    super(props)
    this.state = {
      TotalCustomers: 0,
      WebsiteDetails: 0,
      loading: false,
      modal_standard_create: false,
      modal_standard_edit: false,
      id: "",
      name: "",
      icon: "",
      contacts: "",
      help: "",
      website: "",
      position: 1,
      is_active: true,
    }

    // Initialize notification helpers
    const notifications = createNotificationHelpers();
    this.notify_info = notifications.notify_info;
    this.notify_error = notifications.notify_error;
    this.notify_success = notifications.notify_success;
  }

  /**
   * Loads scanner websites from API and updates state
   */
  loadWebsites = async () => {
    this.setState({ loading: false });

    const websites = await loadScannerWebsitesData(this.notify_error);

    if (websites) {
      const records = transformScannerWebsitesToTableData(
        websites,
        SCANNER_WEBSITE_TABLE_COLUMNS,
        this.edit_scanner_website
      );

      this.setState({
        TotalCustomers: websites.length,
        WebsiteDetails: records,
        loading: true
      });

      this.notify_success(MESSAGES.SCANNER_WEBSITE_LOADED_SUCCESS);
    }
  }

  componentDidMount() {
    this.loadWebsites();
  }


  create_scanner_website = () => {
    this.setState(prevState => ({
      name: "",
      icon: "",
      is_active: false,
      contacts: "",
      help: "",
      website: "",
      position: 1,
      modal_standard_create: !prevState.modal_standard_create,
    }))
  }

  edit_scanner_website = (id, name, icon, is_active, contacts, help, website, position) => {
    this.setState(prevState => ({
      id,
      name,
      icon,
      is_active,
      contacts,
      help,
      website,
      position,
      modal_standard_edit: !prevState.modal_standard_edit,
    }))
  }

  handleInputChange = (e) => {
    if (e.target.name === "is_active") {
      this.setState({ [e.target.name]: !this.state[e.target.name] });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  /**
   * Creates a new scanner website
   */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { name, icon, is_active, contacts, help, website, position } = this.state;

    const success = await createScannerWebsite(
      { name, icon, is_active, contacts, help, website, position: parseInt(position) },
      this.notify_error
    );

    if (success !== null) {
      this.setState({ modal_standard_create: false });
      this.notify_success(MESSAGES.SCANNER_WEBSITE_CREATED_SUCCESS);
      window.location.reload();
    }
  }

  /**
   * Updates a scanner website
   */
  updateScannerWebsite = async (e) => {
    e.preventDefault();
    const { id, name, icon, is_active, contacts, help, website, position } = this.state;

    const success = await updateScannerWebsite(
      { id, name, icon, is_active, contacts, help, website, position: parseInt(position) },
      this.notify_error
    );

    if (success !== null) {
      this.setState({ modal_standard_edit: false });
      this.notify_success(MESSAGES.SCANNER_WEBSITE_UPDATED_SUCCESS);
      window.location.reload();
    }
  }

  render() {
    const {
      WebsiteDetails,
    } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>
            <title>Veeper | AP - Customers</title>
          </Helmet>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.props.t("Scanner Website")}
              breadcrumbItem={this.props.t("Scanner Website")}
            />
            <ToastContainer />
            <Row>
              <Col xl={12}>
                {this.state.loading ? (
                  <React.Fragment>
                    <div className="" style={{ "textAlign": "right", "paddingBottom": "10px" }}>
                      <span className="loading"></span>
                      <Button
                        color="primary"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={this.create_scanner_website}
                        data-toggle="modal"
                        data-target="#myModal"
                      >Create</Button>
                    </div>
                    <WebsiteList websites={WebsiteDetails} />

                  </React.Fragment>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
                    <Spinner color="primary" />
                    <span style={{ marginLeft: '10px' }}>Loading ...</span>
                  </div>
                )}
              </Col>
            </Row>
            <Modal
              isOpen={this.state.modal_standard_create}
              toggle={this.create_scanner_website}
              size='lg'
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Create Scanner Website
                </h5>
                <button
                  type="button"
                  onClick={() =>
                    this.setState({ modal_standard_create: false })
                  }
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Name
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="name"
                            placeholder="Name"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.name}
                            onChange={this.handleInputChange}
                            required
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Icon
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="icon"
                            placeholder="Icon"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.icon}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Contacts
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="contacts"
                            placeholder="Please write email"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.contacts}
                            onChange={this.handleInputChange}
                            required
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Help
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="help"
                            placeholder="Help Text"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.help}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Website
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="website"
                            placeholder="domain of website"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.website}
                            onChange={this.handleInputChange}
                            required
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Position
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="number"
                            name="position"
                            placeholder="Position of the list"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.position}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Status
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="checkbox"
                            name="is_active"
                            placeholder="Status"
                            className="form-control"
                            id="horizontal-is_active-Input"
                            value={Boolean(this.state?.is_active)}
                            onChange={this.handleInputChange}
                            checked={Boolean(this.state?.is_active)}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="w-md"
                            >
                              Submit
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Modal
              isOpen={this.state.modal_standard_edit}
              toggle={this.edit_scanner_website}
              size='lg'
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Edit Scanner Website
                </h5>
                <button
                  type="button"
                  onClick={() =>
                    this.setState({ modal_standard_edit: false })
                  }
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <Card>
                  <CardBody>
                    <Form onSubmit={this.updateScannerWebsite}>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Name
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="name"
                            placeholder="Auto BCL Name"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.name}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Icon
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="icon"
                            placeholder="Icon"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.icon}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Contacts
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="contacts"
                            placeholder="Please write email"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.contacts}
                            onChange={this.handleInputChange}
                            required
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Help
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="help"
                            placeholder="Help Text"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.help}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Website
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="text"
                            name="website"
                            placeholder="domain of website"
                            className="form-control"
                            id="horizontal-name-Input"
                            value={this.state?.website}
                            onChange={this.handleInputChange}
                            required
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Position
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="number"
                            name="position"
                            placeholder="Position of the list"
                            className="form-control"
                            id="horizontal-icon-Input"
                            value={this.state?.position}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-is_active-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Status
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="checkbox"
                            name="is_active"
                            placeholder="Status"
                            className="form-control"
                            id="horizontal-is_active-Input"
                            onChange={this.handleInputChange}
                            checked={this.state?.is_active}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="w-md"
                            >
                              Update
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>
          </Container>
        </div>

      </React.Fragment>
    )

  }
}

ScannerWebsite.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(ScannerWebsite)
